import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import config from "./i18next-parser.config.js";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat"
import 'dayjs/locale/en-gb'
import 'dayjs/locale/fr'


function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

//default locale for dayjs
dayjs.locale("fr")
dayjs.extend(localizedFormat)



try{
    let lang=getCookie("wp-wpml_current_language");
    if(lang!==""){
        if(lang==="en"){
            dayjs.locale("en-gb");
        }else{
            dayjs.locale(lang)
        }
    }
}catch{};

const resources = {
  en: {
    translation: enTranslation
  }
};

const languageDetector = new LanguageDetector(null, {
     lookupCookie: 'wp-wpml_current_language',
});

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(languageDetector)
  .init({
    resources,
    ...config
  });
  export {getCookie};
  export default i18n;